
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rat-race/privacy-policy",
      function () {
        return require("private-next-pages/rat-race/privacy-policy.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rat-race/privacy-policy"])
      });
    }
  